import Settings from "./settings.service";
import Storage from "../services/storage.service";
import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import Errors from "./errors.service";
import CONSTANTS from "./constants.service";

var TopupPayments = {};

TopupPayments.createApplePaymentRequest = () => {
	let totals = Storage.get("topupPaymentAmount", true);
	Helpers.debug_payment("totals", totals);
	return {
		countryCode: Settings.apple_pay_country_code,
		currencyCode: Settings.apple_pay_currency,
		supportedNetworks: Settings.apple_pay_supported_networks,
		merchantCapabilities: ["supports3DS"],
		total: { label: "Total", amount: totals },
		version: Settings.apple_pay_version_number,
	};
};

TopupPayments.getPaymenOperation = (operation) => {
	switch (operation) {
		case "purchaseWithAuth":
			return 11;
		case "auth":
			return 13;
		case "purchase":
			return 14;
		default:
			return 11;
	}
};

TopupPayments.getAppleParameters = (paymentToken) => {
    const topNumberData = Storage.get("TopNumberData",true)
	let data = {};
	data["apple_network"] = paymentToken?.paymentMethod?.network || "";
	data["apple_displayName"] = paymentToken?.paymentMethod?.displayName || "";
	data["apple_type"] = paymentToken?.paymentMethod?.type;
	data["apple_data"] = paymentToken?.paymentData?.data;
	data["data"] = topNumberData;
	data["apple_signature"] = paymentToken?.paymentData?.signature;
	data["apple_transactionId"] = paymentToken?.paymentData?.header?.transactionId;
	data["apple_ephemeralPublicKey"] = paymentToken?.paymentData?.header?.ephemeralPublicKey;
	data["apple_publicKeyHash"] = paymentToken?.paymentData?.header?.publicKeyHash;
	data["apple_application_data"] = "";
	data["payment_operation"] = TopupPayments.getPaymenOperation();
	return data;
};

TopupPayments.registerAndPayApple = (data) => {
	let config = {
		method: "post",
		url: "/quick_topup/online_oneoff_applepay",
		data: data,
	};
	return HTTP(config);
}

TopupPayments.sendPaymentToken = (paymentToken) => {
	return new Promise(function (resolve, reject) {
		let data = TopupPayments.getAppleParameters(paymentToken);
		TopupPayments.registerAndPayApple(data)
			.then((res) => {
				resolve(res);
			})
			.catch((error) => {
				reject(error);
			});
	});
};


TopupPayments.validateAppleUrlNew = () => {
	let config = {
		method: "post",
		url: "apple/request_payment_session_new",
	};
	return HTTP(config);
};

TopupPayments.appleBegin = () => {
	let request = TopupPayments.createApplePaymentRequest(); // PKPaymentRequest

	let session = new window.ApplePaySession(
		Settings.apple_pay_version_number,
		request
	);
				session.begin();
				Helpers.debug_payment("session.begin()");

				session.oncancel = (event) => {
					Helpers.debug_payment("session.oncancel event", event);
					Storage.clear("selected_payment_method");
					Storage.set("paymentSuccess", false, true);
					window.location.href = "/join/#/apple-pay-top-up-failure";
				};

				session.onpaymentauthorized = (event) => {
					Helpers.debug_payment("session.onpaymentauthorized event", event);
					TopupPayments.sendPaymentToken(event.payment.token)
						.then((res) => {

							Helpers.debug_payment("sendPaymentToken res", res);

							let status = window.ApplePaySession.STATUS_SUCCESS;
							session.completePayment(status);
							Storage.set("apple_pay_success", true);

							Storage.set("paymentSuccess", true, true)
							window.location.href = '/join/#/confirmation-apple-top-up';
							
						})
						.catch((error) => {
							session.abort();
							Storage.set("paymentSuccess", false, true);
							window.location.href = "/join/#/apple-pay-top-up-failure";
						});
				};

				session.onvalidatemerchant = (event) => {

					Helpers.debug_payment("session.onvalidatemerchant event", event);
					if (event.validationURL) {

						TopupPayments.validateAppleUrlNew()
							.then((merchantSession) => {
								Helpers.debug_payment("merchantSession", merchantSession);
								session.completeMerchantValidation(merchantSession.data);
							})
							.catch((error) => {
								Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
								session.abort();
								Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
							});
					} else {
						Helpers.debug_payment("ERROR_MERCHANT_VALIDATION");
						Errors.handleError(CONSTANTS.ERROR_MERCHANT_VALIDATION);
					}
				};
};

TopupPayments.creditCardsKnetPayment = (data) => {
	let config = {
		method: "post",
		url: "/quick_topup/knet_online_oneoff",
		data: { data },
	}
	return HTTP(config)
}

TopupPayments.paymentKnetTopup = (data) => {
	TopupPayments.creditCardsKnetPayment(data)
		.then(response => {
			if (response && response.data && response.data.Status && response.data.HTML_ANSWER) {
				let order_id = {};
				let status = {};
				order_id[Storage.get("session")] = response.data.OrderID;
				status[Storage.get("session")] = response.data.Status;

				Storage.set("order_id", JSON.stringify(order_id), true);
				Storage.set("status", JSON.stringify(status), true);
				window.location.href = response.data.HTML_ANSWER;
			} else {
				// window.location.href="http://localhost:3000/join#/confirmation?session=15"	
				Storage.set("payment_error", true);
				Storage.clear("selected_payment_method");
				throw new Error("Failed to load Knet payment");
			}
		})
		.catch(error => {
			Storage.clear("selected_payment_method");
			Errors.handleError();
		})
}

TopupPayments.topupSaveCard = (data) => {
	Helpers.debug_payment("Payments.topupSaveCard(data)", data);
	let config = {
		method: "post",
		url: "/quick_topup/online_oneoff",
		data: data,
	};
	return HTTP(config);
};

TopupPayments.topupVerifyConfirmationResponse = (data) => {
	Helpers.debug_payment("Payments.topupVerifyConfirmationResponse(data)", data);
	let config = {
		method: "post",
		url: "/quick_topup/online_oneoff_confirmation",
		data: data,
	};
	return HTTP(config);
};

export default TopupPayments;
